module.exports = __webpack_public_path__ + "img/hospitality-cent-cards.b7e8ee43.jpg";